export const isCancelationServiceActive = (state) => state.isCancelationServiceActive;
export const isLoadingCancelationServiceDate = (state) => state.isLoadingCancelationServiceDate;
export const newlyInsuredPersons = (state) => state.newlyInsuredPersons;
export const addInsuredStartDate = (state) => state.startDate?.value;
export const addInsuredStartDateOption = (state) => state.startDate;
export const currentlySelectedAgreementId = (state) => state.selectedAgreementId;
export const shouldResetSelectedAgreementId = (state) => state.shouldResetSelectedAgreementId;
export const shouldRefreshContracts = (state) => state.shouldRefreshContracts;

export const hasPartnerInAddInsuredForms = (state) =>
  Object.values(state.newlyInsuredPersons).some((x) => x.role === 'P');
export const canPickStartDate = function (state) {
  const forms = Object.values(state.newlyInsuredPersons);
  return forms.length > 1 || (forms.length === 1 && !forms[0].isBornRecently);
};
